import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useModal } from '../../../hooks/use-modal';

import { Button } from 'ui-components/components/button';
import { ModalPortal } from '../../../components/modal-portal';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';

import { MultiPackageModal } from '../../../components/modals/multi-package-modal';
import { useSupportsMultiPackage } from '../../../hooks/fulfillment-planner/use-supports-multi-package';
import { useShouldRequirePackageContentDescription } from '../../../fulfillment-planner/package-content-description';

export const MultiPackage = () => {
  const { isOpen, open, close } = useModal();
  const { hasInsuranceProviderSelected, packages: orderPackages, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();
  const packageCount = orderPackages.length;
  const shouldRequirePackageDescription = useShouldRequirePackageContentDescription();

  const { serviceId } = serviceIdAndSellerLabelProviderId;
  const supportsMultiPackage = useSupportsMultiPackage(serviceId);

  if (!supportsMultiPackage) {
    return null;
  }

  return (
    <>
      <Button onClick={open} theme='link'>
        <FormattedMessage
          defaultMessage='Multi-Package ({packageCount})'
          description='shipmentDisplay.multiPackage'
          id='xDlfgO'
          values={{ packageCount }}
        />
      </Button>
      {isOpen && (
        <ModalPortal onClose={close}>
          <MultiPackageModal
            hasInsuranceProviderSelected={hasInsuranceProviderSelected}
            hasMultiPackageSupport={supportsMultiPackage}
            initialPackages={orderPackages}
            readOnly
            shouldRequirePackageDescription={shouldRequirePackageDescription}
          />
        </ModalPortal>
      )}
    </>
  );
};
